import actions from './actions'

const initialState = {
  user: {},
  permissions: [],
  isAdmin: false,
  token: '',
  authorized: false,
  loading: false,
  dataLoading: false,
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
